import { DataFetchWrapper } from "@tfg/ui"

import { FAQAdmin } from "~/pages/Admin/FAQ/FAQAdmin"

import { useFAQQuery } from "./hooks"

export const FAQAdminWrapper = () => {
  const faqQuery = useFAQQuery()

  return (
    <DataFetchWrapper query={faqQuery}>
      {({ data }) => <FAQAdmin faqs={data} />}
    </DataFetchWrapper>
  )
}
